<template>
  <div
    id="progress-line"
    class="h-1 bg-indigo-500"
  />
</template>

<style lang="scss">

#progress-line {
  animation: progress 15s ease-out;
}

@keyframes progress {
  0% {
    width: 0%;
  }
  
  5% {
    width: 10%;
  }
  
  10% {
    width: 20%;
  }
  
  15% {
    width: 25%;
  }
  
  75% {
    width: 75%;
  }
  
  100% {
    width: 95%;
}
}
</style>
